import { Component, inject } from '@angular/core';
import { MatButton } from '@angular/material/button';
import { MAT_DIALOG_DATA, MatDialogActions, MatDialogClose, MatDialogContent, MatDialogRef, MatDialogTitle } from '@angular/material/dialog';
import { DocumentSelectOption } from '@gsm/entities';
import { DEFAULT_ACCEPT_FILETYPES } from '../../shared-models/default-accept-filetypes.model';
import { UploadDokument } from '../../shared-models/upload-dokument.model';
import { DragDropDokumentPickerChange, DragDropDokumentPickerComponent } from '../drag-drop-dokument-picker/drag-drop-dokument-picker.component';

export interface DokumentPickerDialogData {
  documentTypes: DocumentSelectOption[];
  acceptedFileTypes?: string[];
}

@Component({
  selector: 'gsm-dokument-picker-dialog',
  templateUrl: './dokument-picker-dialog.component.html',
  styleUrls: ['./dokument-picker-dialog.component.scss'],
  standalone: true,
  imports: [
    MatDialogTitle,
    MatDialogContent,
    DragDropDokumentPickerComponent,
    MatDialogActions,
    MatButton,
    MatDialogClose
  ]
})
export class DokumentPickerDialogComponent {
  dialogRef = inject<MatDialogRef<DokumentPickerDialogComponent>>(MatDialogRef);
  data = inject<DokumentPickerDialogData>(MAT_DIALOG_DATA);

  documents: UploadDokument[] = [];
  formValid = false;

  onDocumentsUpdate(update: DragDropDokumentPickerChange) {
    this.documents = update.data;
    this.formValid = update.isValid;
  }

  onCancelClick() {
    this.dialogRef.close();
  }

  get acceptedFileTypes(): string[] {
    return (this.data && this.data.acceptedFileTypes) || DEFAULT_ACCEPT_FILETYPES;
  }
}
